export function setUserData(data) {
    return {type: "SET_USER_LOGIN_DATA", payload: data}
}

export function setUserPermissions(data) {
    return {type: "SET_USER_PERMISSIONS", payload: data}
}

export function setUserScreens(data) {
    return {type: "SET_USER_SCREENS", payload: data}
}

export function setUserDataEmail(data) {
    return {type: "SET_USER_LOGIN_DATA_EMAIL", payload: data}
}

export function setSecondaryEmail(data){
    return {type: "SET_SECONDARY_EMAIL", payload: data}
}

export function setFirstAccess(data){
    return {type: "SET_FIRST_ACCESS", payload: data}
}
